import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": _ctx.isModalVisible,
    title: "Warning",
    icon: "cart-plus",
    "data-qa": "go-to-checkout-modal"
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent",
        onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onAlternativeAction && $options.onAlternativeAction(...args)), ["prevent"])),
        "data-qa": "modal-button:ReviewYourPledge"
      }, "review your pledge"),
      _createElementVNode("button", {
        type: "button",
        class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide _ml-3",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onContinueAction && $options.onContinueAction(...args)), ["prevent"])),
        "data-qa": "modal-button:ProceedWithOrder"
      }, " Go to checkout ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createTextVNode(" You added items with different ", -1 /* CACHED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartIntegrity.optionsWithMixedValues, (option, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `selection-option-${option}`,
            "data-qa": `selection-option-${option}`
          }, [
            _createTextVNode(_toDisplayString(index === 0 ? '' : index + 1 === _ctx.nonUniqueItemOptions.Count ? ' and ' : ', '), 1 /* TEXT */),
            _createElementVNode("strong", null, _toDisplayString(option), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_1))
        }), 128 /* KEYED_FRAGMENT */)),
        _cache[3] || (_cache[3] = _createTextVNode(" options to your pledge. Do you want to proceed to checkout? ", -1 /* CACHED */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible"]))
}